import { MobileDialog } from "./MobileDialog";

export default MobileDialog;
